import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { AuthRouteTables } from "../../types/types";
import { AdPlacement } from "./AdPlacement";
import "./styles/ad-rail.css";

interface AdSideRailLayoutProps {
  children: ReactNode;
}

const isAdFreeRoute = (pathname: string): boolean =>
  /admin|\/tcg\//i.test(pathname) || pathname === AuthRouteTables.AUTH;

export const AdSideRailLayout = ({ children }: AdSideRailLayoutProps) => {
  const { pathname } = useLocation();

  if (isAdFreeRoute(pathname)) {
    return <>{children}</>;
  }

  return (
    <div className="grid w-full min-w-0 max-w-full flex-[1_0_auto] grid-cols-[minmax(0,1fr)] items-start gap-5 self-stretch [grid-template-areas:'content'] min-[1280px]:grid-cols-[minmax(7.5rem,10rem)_minmax(0,1fr)_minmax(7.5rem,10rem)] min-[1280px]:gap-x-5 min-[1280px]:gap-y-4 min-[1280px]:[grid-template-areas:'left_content_right'] min-[1600px]:grid-cols-[minmax(9rem,11rem)_minmax(0,1fr)_minmax(9rem,11rem)] min-[1600px]:gap-x-7 min-[1600px]:gap-y-5">
      <aside
        className="hidden min-w-0 [grid-area:left] min-[1280px]:sticky min-[1280px]:top-28 min-[1280px]:block"
        aria-label="Advertisement"
      >
        <AdPlacement placement="sideRailLeft" />
      </aside>
      <div className="min-w-0 w-full max-w-full flex-col items-stretch [grid-area:content] flex [&>*]:w-full [&>*]:min-w-0 max-[1279px]:pb-[calc(90px+1.75rem+env(safe-area-inset-bottom))]">
        {children}
      </div>
      <aside
        className="hidden min-w-0 [grid-area:right] min-[1280px]:sticky min-[1280px]:top-28 min-[1280px]:block"
        aria-label="Advertisement"
      >
        <AdPlacement placement="sideRailRight" />
      </aside>
      <div
        className="fixed inset-x-0 bottom-0 z-40 border-t border-white/[0.08] bg-[rgba(16,16,29,0.92)] p-[0.5rem_0.75rem_calc(0.5rem+env(safe-area-inset-bottom))] backdrop-blur-[10px] min-[1280px]:hidden"
        aria-label="Advertisement"
      >
        <AdPlacement placement="mobileStickyBottom" />
      </div>
    </div>
  );
};
